import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=11e51328"
import script from "./Sources.vue?vue&type=script&lang=js"
export * from "./Sources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e51328')) {
      api.createRecord('11e51328', component.options)
    } else {
      api.reload('11e51328', component.options)
    }
    module.hot.accept("./Sources.vue?vue&type=template&id=11e51328", function () {
      api.rerender('11e51328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Sources.vue"
export default component.exports